import { get as apiGet, TYPE_BROOKLYN } from 'api-client'
import _assign from 'lodash/assign'
import _cloneDeep from 'lodash/cloneDeep'
import _get from 'lodash/get'
import _map from 'lodash/map'
import _parseInt from 'lodash/parseInt'
import _range from 'lodash/range'
import { TYPE_PLACEHOLDER } from 'services/content-type'
import { format as formatDateTime } from 'services/date-time'

const SCHEMA = {
  limit: null,
  page: null,
  currentPage: 0,
  totalCount: 0,
  totalPages: 0,
  title: null,
  description: null,
  articles: [],
  _dataError: null,
}

const ARTICLE_TILE_SCHEMA = {
  id: null,
  type: null,
  title: null,
  description: null,
  path: null,
  keyImage: {
    small: null,
    mediumSmall: null,
    medium: null,
    large: null,
  },
  createdTimestamp: null,
  author: null,
  authorPath: null,
  vote: null,
  voteDown: null,
}

export const TILES_ARTICLE_DEFAULT_LIMIT = 18

export function getPlaceholderTilesArticle () {
  return _map(_range(-3, 0), () => ({ type: TYPE_PLACEHOLDER }))
}

/**
 * Get a list of tiles that are articles.
 * @param {object} options - The options
 * @param {string} options.locale - The locale for the request
 * @param {number} options.page - The page number
 * @param {number} options.limit - Limit the number of articles
 * @param {string} options.xff - The X-FORWARDED-FOR header value
 */
export async function get (options) {
  const {
    locale,
    page = 0,
    limit = TILES_ARTICLE_DEFAULT_LIMIT,
    xff,
  } = options
  // api/articles?p=0&pp=22
  try {
    const res = await apiGet('articles', { p: page, pp: limit }, { xff }, TYPE_BROOKLYN)
    return handleArticlesResponse(res, locale, page, limit)
  } catch (e) {
    return handleArticlesResponse({}, locale, page, limit, true)
  }
}

export function handleArticlesResponse (res, locale, page, limit, _dataError) {
  const data = _get(res, 'body', {})
  return createModel(data, locale, page, limit, _dataError)
}

function createModel (data, locale, page, limit, _dataError) {
  const totalCount = _parseInt(_get(data, 'totalCount', 0))
  const currentPage = _parseInt(_get(data, 'currentPage', 1))
  const totalPages =
    totalCount > 0 && limit > 0 ? Math.ceil(totalCount / limit) : 0
  return _assign(_cloneDeep(SCHEMA), {
    _dataError,
    limit,
    page,
    currentPage,
    totalCount,
    totalPages,
    title: _get(data, 'title', ''),
    description: _get(data, 'description', ''),
    articles: _map(_get(data, 'articles', []), article =>
      createArticleTileModel(article, locale),
    ),
  })
}

function createArticleTileModel (article, locale) {
  const createdTimestamp = _parseInt(_get(article, 'created', -1))
  return _assign(_cloneDeep(ARTICLE_TILE_SCHEMA), {
    id: _parseInt(_get(article, 'nid', null)),
    type: _get(article, 'type', ''),
    title: _get(article, 'title', null),
    description: _get(article, ['fields', 'teaser', 0, 'value'], ''),
    path: _get(article, 'path', null),
    keyImage: {
      small: _get(article, ['article_main_image', 'article_304x171'], ''),
      mediumSmall: _get(article, ['article_main_image', 'article_570x321'], ''),
      medium: _get(article, ['article_main_image', 'article_820x461'], ''),
      large: _get(article, ['article_main_image', 'article_1070x602'], ''),
    },
    createdTimestamp,
    dateTimeText: formatDateTime(createdTimestamp * 1000, locale),
    author: _get(article, ['article_author', 'name'], ''),
    authorPath: _get(article, ['article_author', 'path'], ''),
    vote: _get(article, ['fivestar', 'up_count', 'value'], 0),
    voteDown: _get(article, ['fivestar', 'down_count', 'value'], 0),
  })
}
